export const pmFieldClass =
  'h-10 w-full rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--background))] px-3 text-sm text-[hsl(var(--foreground))] placeholder:text-[hsl(var(--muted-foreground))] focus:border-[#0088cc] focus:outline-none focus:ring-1 focus:ring-[#0088cc]';

export const pmTextareaClass =
  'w-full rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--background))] px-3 py-2 text-sm text-[hsl(var(--foreground))] placeholder:text-[hsl(var(--muted-foreground))] focus:border-[#0088cc] focus:outline-none focus:ring-1 focus:ring-[#0088cc]';

export const pmLabelClass = 'mb-1.5 block text-sm font-medium text-[hsl(var(--foreground))]';

export const pmTableWrapClass =
  'overflow-x-auto rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] shadow-sm';

export const pmThClass =
  'px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-[hsl(var(--muted-foreground))]';

export const pmTdClass = 'px-4 py-3 text-sm text-[hsl(var(--foreground))]';

export const pmTrClass =
  'border-b border-[hsl(var(--border))] last:border-0 hover:bg-[hsl(var(--muted))]/40';

export const pmIconBtnClass =
  'rounded-lg p-2 text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--muted))] hover:text-[hsl(var(--foreground))]';

export const pmDangerIconBtnClass =
  'rounded-lg p-2 text-[hsl(var(--muted-foreground))] hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-950/40 dark:hover:text-red-300';

export function pmStatusClass(active: boolean) {
  return `inline-flex rounded-md px-2 py-0.5 text-xs font-medium ${
    active
      ? 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400'
      : 'bg-rose-500/10 text-rose-700 dark:text-rose-400'
  }`;
}

export const pmOverlayClass =
  'fixed inset-0 z-[2000] bg-black/60 backdrop-blur-md';

export const pmDialogClass =
  'flex max-h-[90vh] w-full flex-col overflow-hidden rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--card))] shadow-2xl';

export const pmDrawerClass =
  'flex h-full w-full max-w-2xl flex-col overflow-hidden border-l border-[hsl(var(--border))] bg-[hsl(var(--card))] shadow-2xl';

export const pmSectionTitleClass =
  'text-xs font-semibold uppercase tracking-wide text-[hsl(var(--muted-foreground))]';

export const pmCardClass =
  'rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--background))] p-3';

export const pmSelectBtnClass =
  'h-10 rounded-lg border-[hsl(var(--border))] bg-[hsl(var(--background))] py-0 text-[hsl(var(--foreground))] hover:border-[#0088cc] focus:ring-1 focus:ring-[#0088cc]';

